import React, { Component } from "react"

/* Components */
import { Card } from "@cuba-go/poker-ui"

/* utils */
import { get_unique_values } from "../constants/utils"


/* ONE BOX OF FIVE CARDS

   The cards are dealt face up and the hand reads itself the moment the fifth lands. It is
   then laid out the way it goes on the cloth: what makes the combination pushed up, the
   rest below. Three for a Niu, four for a four of a kind, and a single high card for a
   hand that has nothing. */
class PlayerCards extends Component {

    /* The five cards in the order they are read. Until the hand is complete there is
       nothing to read, so they stand three over two as they were dealt — the split does
       not move under the player when the fifth card lands. */
    laid = () => {

        const { cards, game } = this.props

        const list = cards ? get_unique_values(cards, "id") : []

        if (game && game.data && game.data.length === list.length) {
            return game.data
        }

        return list.map((card, index) => ({ ...card, status: index < 3 }))
    }

    /* A card of the upper row is marked, not animated: it carries the glow that says it is
       one of the three the hand is made of, and nothing that moves. It used to be given a
       bounce that ran for as long as the card was on the table, and while the hand is still
       being dealt the upper row is only a provisional three — so on every box, all the way
       through the deal, three cards no one had read yet were hopping on the cloth. */
    _card = card => (
        <div className={`niu--player-card ${card.status ? "niu--player-card-up" : ""}`} key={`card-${card.uid ? card.uid : card.id}`}>
            <div className="niu--player-flip-card active">
                <div className="niu--player-flip-card-inner">
                    <div className="niu--player-flip-card-front">
                        <Card closed={true} />
                    </div>
                    <div className="niu--player-flip-card-back">
                        <Card data={card.name} />
                    </div>
                </div>
            </div>
        </div>
    )

    /* WHAT THE BOX IS CALLED ONCE ITS HAND CAN BE READ

       The combination is not a label hung under the cards — it is what the box has, so it
       is said where the box is named: "Бокс - 3" while the cards are still coming, "Бокс - 3
       Ню 4" from the moment the fifth lands. It used to sit in a pill below the row, which
       put the one thing the player is waiting for as far from the box's name as the box is
       tall.

       Nothing is drawn until there is a hand, and the line is the same height either way,
       so the box does not change shape when the name arrives. */
    _name = () => {

        const { game } = this.props

        if (!game) return null

        /* No three of the five come to ten — there is no combination, only a high card */
        const none = parseInt(game.level) === 0 ? "niu--player-combination-none" : ""

        return <span className={`niu--player-combination ${none}`}>{game.name}</span>
    }

    /* One row of the hand while it is still being dealt: a fixed run of places, each
       either holding the card that landed in it or standing empty and waiting for it.

       Empty places are what keep the table still. Without them a box is only as wide as
       the cards it has so far, so every card that lands shoves its neighbours sideways
       and the whole row walks about the screen for the length of the deal. */
    _places = (cards, count, from, className = "") => (
        <div className={`niu--player-row ${className}`}>
            {Array.from(Array(count).keys()).map(i => {

                const card = cards[from + i]

                return (
                    <div className="niu--player-card-place" key={`place-${from + i}`}>
                        {card ? this._card(card) : null}
                    </div>
                )
            })}
        </div>
    )

    render = () => {

        const { style, box, boxState, staked, game } = this.props

        const laid = this.laid()

        const up = laid.filter(card => card.status)
        const down = laid.filter(card => !card.status)

        /* A box this player has nothing on is still dealt and still shown — every box is
           open to everyone — but it steps back out of the way of the ones he is in. Once
           he is in none of them there is no "his" box, and all three read alike. */
        const dim = staked && !boxState ? 0.5 : 1

        return (
            <div className="niu-player-game" style={{ opacity: dim }} key={`boxcards-${box}`}>
                <div className={`niu--player-card-container ${style ? style : ""}`}>
                    <div className="niu--player">

                        <h2>Бокс - {box + 1}{this._name()}</h2>

                        {/* Until the fifth card lands there is no combination to lay out,
                            so the hand stands in its places: three over two, the shape it
                            will keep. Once the hand can be read the places go and the
                            cards take the split the combination gives them — which may
                            be four over one for a four of a kind. */}
                        <div className="niu--player-box">
                            {game ?
                                <div className="niu--player-hand">
                                    <div className="niu--player-row niu--player-row-up">
                                        {up.map(card => this._card(card))}
                                    </div>
                                    <div className="niu--player-row niu--player-row-down">
                                        {down.map(card => this._card(card))}
                                    </div>
                                </div>
                                :
                                <>
                                    {this._places(laid, 3, 0, "niu--player-row-up")}
                                    {this._places(laid, 2, 3, "niu--player-row-down")}
                                </>
                            }
                        </div>

                    </div>
                </div>
            </div>
        )
    }

}

export default PlayerCards
